import "./styles.scss";
import { ServiceSearch } from "../../js/appointments/service-search";
import { ServicesDetail } from "../../js/services-detail";

new ServicesDetail();
new ServiceSearch();
